import {css, html, LitElement, PropertyValues, unsafeCSS} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import flatpickr from 'flatpickr';
// @ts-ignore
import flatpickerStyles from 'flatpickr/dist/flatpickr.css?raw';
import {SpUiConfigService} from '../../services/sp-ui-config.service';
import {key as LocaleKey} from 'flatpickr/dist/types/locale';

@customElement('sp-flatpickr')
export class SpFlatpickr extends LitElement {
    static get styles() {
        return [
            //language=css
            unsafeCSS(flatpickerStyles),
            //language=css
            css`
                :host {
                    width: 100%;
                }
                
                .flatpickr-calendar {
                    width: 100%;
                }

                .flatpickr-calendar.inline {
                    top: 0;
                }

                .flatpickr-day.selected {
                    background: rgb(var(--sp-color-a));
                    border-color: rgb(var(--sp-color-a));
                }

                .flatpickr-day.selected:hover {
                    background: rgb(var(--sp-color-a));
                    border-color: rgb(var(--sp-color-a));
                }
                
                .flatpickr-rContainer {
                    width: 100%;
                }
                
                .flatpickr-days {
                    width: 100%;
                }
                
                .dayContainer {
                    width: 100%;
                    max-width: 100%;
                }
            `
        ];
    }

    @property({type: Object})
    value: Date;

    @property({type: String})
    locale: LocaleKey;

    flatpickrInstance;
    loadedLanguages = new Set<string>();

    protected async updated(_changedProperties: PropertyValues) {
        super.updated(_changedProperties);
        if (_changedProperties.has('value') && this.flatpickrInstance && this.value) this.flatpickrInstance.setDate(this.value);
        if (_changedProperties.has('locale') && this.locale) {
            if (!this.loadedLanguages.has(this.locale)) {
                let script = document.createElement('script');
                script.onload = this.languageLoaded.bind(this);
                script.src = `${ SpUiConfigService.get('SP_STATIC_ASSET_HOST') }/3rdparty/flatpickr/l10n/${this.locale === 'en' ? 'default' : this.locale}.js`;
                this.shadowRoot.appendChild(script);
                this.loadedLanguages.add(this.locale);
            } else {
                this.languageLoaded();
            }
        }
    }

    languageLoaded() {
        const elem = this.shadowRoot.getElementById('flatpickr');
        this.flatpickrInstance = flatpickr(elem, {
            inline: true,
            enableTime: true,
            time_24hr: true,
            locale: this.locale,
            onChange: this.emitChangedEvent.bind(this),
            ...this.value && { defaultDate: this.value }
        });
    }

    render() {
        return html`
            <div id="flatpickr"></div>
        `;
    }

    protected emitChangedEvent(selectedDates, dateStr, instance): void {
        this.dispatchEvent(
            new CustomEvent('valueChanged',
                { bubbles: true, composed: true, detail: {
                        value: Array.isArray(selectedDates) && selectedDates.length > 0 ? selectedDates[0] : null
                    } })
        );
    }
}

export interface FlatpickrValueChanged extends Event {
    detail: {
        value: Date;
    }
}
